<template>
  <el-row class="text-center">
    <div class="step-indicator">
      <div v-for="step in totalSteps" :key="step" :class="{'step': true, 'current': step === currentStep, 'complete': step < currentStep}">{{ step }}</div>
    </div>
  </el-row>
</template>

<script>
export default {
  name: 'HorizontalSteps',
  props: {
    totalSteps: {
      type: Number,
      default: 2
    },
    currentStep: {
      type: Number,
      default: 1
    },
    showNavigation: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    prevStep () {
      if (this.currentStep > 1) {
        this.currentStep--
        this.$emit('step-changed', this.currentStep)
      }
    },
    nextStep () {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++
        this.$emit('step-changed', this.currentStep)
      }
    }
  }
}
</script>

<style scoped>
.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.step {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #FFFFFF;
  color: #1B8BD9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 90px;
  border: solid 2px #1B8BD9;
  position: relative;
  font-size: 1.5rem;
  font-weight: 600;
}

.step.current {
  background-color: #1B8BD9;
  border-color: #1B8BD9;
  color: #FFFFFF;
}

.step.complete {
  background-color: #1B8BD9;
  border-color: #1B8BD9;
  color: #FFFFFF;
}

.step:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -120px;
  width: 120px;
  height: 2px;
  z-index: -1;
  background-color: #1B8BD9;
  transform: translateY(-50%);
}
.step:last-child {
  margin-right: 0px;
}
</style>
